'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEntry = undefined;

var _getters = require('./getters');

var getEntry = exports.getEntry = _getters.getEntry;